import { HashLoader } from 'react-spinners';
import './Loader.css';

const Loader = ({style}) => {
    return (
        <div className="overlay" style={style}>
            <HashLoader
                color="#c41f1f"
                loading={true}
                className="loader-div "
                size={50}
            />
        </div>
    );
};
export default Loader;